import {useEffect,useState} from 'react'
import {streamNcfdSnapshots} from '../lib/marketData/ncfdClient.js'

// Lifetime belongs to the signed-in market session, not an asset or card.
export default function useFomoReading(userId,enabled=true) {
  const [state,setState]=useState({owner:userId,snapshot:null,loading:true,failed:false,now:Date.now()})
  useEffect(()=>{
    let disposed=false,controller=null,reconnect,failures=0
    setState(previous=>previous.owner===userId&&userId&&enabled
      ? {...previous,loading:!previous.snapshot}
      : {owner:userId,snapshot:null,loading:!!userId&&enabled,failed:false,now:Date.now()})
    if(!userId||!enabled)return
    async function connect(){
      if(disposed||controller)return
      clearTimeout(reconnect)
      const active=new AbortController();controller=active
      const timeout=setTimeout(()=>active.abort(),28000)
      try {
        await streamNcfdSnapshots({signal:active.signal,onSnapshot:snapshot=>{
          if(disposed)return
          failures=0
          setState(previous=>{
            const {as_of:oldAsOf,...oldReading}=previous.snapshot||{}, {as_of,...reading}=snapshot
            return {...previous,snapshot:JSON.stringify(oldReading)===JSON.stringify(reading)?previous.snapshot:snapshot,loading:false,failed:false,now:Date.now()}
          })
        }})
      }catch{if(!disposed){failures++;setState(s=>({...s,loading:false,failed:true,now:Date.now()}))}}
      finally{clearTimeout(timeout);controller=null;if(!disposed)reconnect=setTimeout(connect,Math.min(30000,1000*2**Math.min(failures,5)))}
    }
    void connect()
    const clock=setInterval(()=>setState(s=>({...s,now:Date.now()})),15000)
    window.addEventListener('online',connect)
    return()=>{disposed=true;controller?.abort();clearTimeout(reconnect);clearInterval(clock);window.removeEventListener('online',connect)}
  },[userId,enabled])
  return state.owner===userId?state:{snapshot:null,loading:true,failed:false,now:Date.now()}
}
